<div class="flex-container min-h-100 flex-pc flex-d-c secondary-bg-color">
  <h2 class="text-center">Opps! no page found</h2>
  <br>
  <h4 class="text-center">May be you have lost</h4>
  <br>
  <a class="btn button button1" [routerLink]="['/']">Go to home</a>
</div>